
import { useTranslation } from 'react-i18next'
import userManager from './userManager'
import Icon from 'Components/Icon'
import { useAppDispatch } from 'Store/selectors'

import { clearApiStates } from 'Utils/resetApiStates'

function SignOutPage() {
  const [t] = useTranslation()
  const dispatch = useAppDispatch()

  // useEffect(() => {
  //   ConfirmAlert(t("LOGOUT_MESSAGE")).then((res) => {
  //     if (res) {
  //       userManager.getUser().then(user => {
  //         if (user)
  //           userManager.signoutRedirect({ 'id_token_hint': user.id_token });
  //       })
  //     } else {
  //       window.history.back()
  //     }
  //   })
  // }, [])

  const signout = async () => {
    // userManager.getUser().then(user => {
    //   if (user)
    //     userManager.signoutRedirect({ state: { path: window.location.pathname }, 'id_token_hint': user.id_token });
    // })
    userManager.removeUser()
    // localStorage.clear();
    userManager.clearStaleState()
    dispatch({ type: 'clearAllStates' })
    await clearApiStates()
    userManager.signinRedirect({ state: { path: '/' }, prompt: 'login' })
  }

  return (
    <div className="fixed inset-0 group/bottomsheet z-10 show-bottomsheet">
      <div
        className="backdrop group-[.show-bottomsheet]/bottomsheet:opacity-100 group-[.show-bottomsheet]/bottomsheet:pointer-events-auto"
        onClick={() => window.history.back()}
      ></div>
      <div className="fixed bottom-0 inset-x-0 flex flex-col z-40 bg-white rounded-t-2xl shadow-sm pt-2 transition-transform translate-y-full group-[.show-bottomsheet]/bottomsheet:translate-y-0 max-h-[95%]">
        <div className="grow flex flex-col overflow-hidden">
          <div className="flex justify-between items-center h-16 px-6 shrink-0">
            <div className="flex justify-between items-center gap-2">
              <div className="text-lg font-bold pl-2">{t('LOGOUT_ACCOUNT')}</div>
            </div>
            <div className="flex justify-between items-center">
              <div className="relative">
                <Icon
                  name="close"
                  className="w-6 h-6 text-gray-600"
                  onClick={() => window.history.back()}
                />
              </div>
            </div>
          </div>
          <div className="p-6 text-black">{t('LOGOUT_MESSAGE')}</div>
          <div className="cta">
            <button className="btn btn-error btn-lg" onClick={signout}>
              {t('LOGOUT_ACCOUNT')}
            </button>
            <button
              className="btn btn-outline-primary btn-lg"
              onClick={() => window.history.back()}
            >
              {t('CANCEL')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignOutPage
